import { v1ServerByProjectAuth } from "server/index/serverInstances";
import { makeQuery } from "server/index/utils";
import {
  deleteWebhookDetailRequest,
  deleteWebhookDetailResponse,
  getEventTypeRequest,
  getEventTypeResponse,
  getWebhookDetailRequest,
  getWebhookDetailResponse,
  getWebhookEventHistoryListAllRequest,
  getWebhookEventHistoryListAllResponse,
  getWebhookEventListRequest,
  getWebhookEventListResponse,
  getWebhookListRequest,
  getWebhookListResponse,
  requestTestWithWebhookRequest,
  requestTestWithWebhookResponse,
  retryFailedSubscribeWebhookRequest,
  retryFailedSubscribeWebhookResponse,
  subscribeWebhookRequest,
  subscribeWebhookResponse,
  updateWebhookDetailRequest,
  updateWebhookDetailResponse,
} from "./index.type";

//웹흑 목록 조회
const getWebhookList = async (
  request: getWebhookListRequest
): Promise<getWebhookListResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/webhook/subscriptions`,
    query: makeQuery(request.query),
  });

//웹훅 상세 조회
const getWebhookDetail = async (
  request: getWebhookDetailRequest
): Promise<getWebhookDetailResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/webhook/subscriptions/${request.params.subscriptionId}`,
    query: makeQuery(request.query),
  });

//웹훅 구독 생성-> 완료
const subscribeWebhook = async (
  request: subscribeWebhookRequest
): Promise<subscribeWebhookResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/webhook/subscriptions`,
    query: makeQuery(request.query),
    data: request.data,
  });

//웹훅 수정 -> 완료
const updateSubscribeWebhookDetail = async (
  request: updateWebhookDetailRequest
): Promise<updateWebhookDetailResponse> =>
  await v1ServerByProjectAuth.put({
    path: `/webhook/subscriptions/${request.params.subscriptionId}`,
    query: makeQuery(request.query),
    data: request.data,
  });

//구독한 웹훅 삭제 -> 완료
const deleteSubscribeWebhookDetail = async (
  request: deleteWebhookDetailRequest
): Promise<deleteWebhookDetailResponse> =>
  await v1ServerByProjectAuth.delete({
    path: `/webhook/subscriptions/${request.params.subscriptionId}`,
    query: makeQuery(request.query),
  });

//웹훅에서 사용자가 구독할 수 있는 이벤트 목록을 조회 -> 완료
const getEventType = async (
  request: getEventTypeRequest
): Promise<getEventTypeResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/webhook/events`,
    query: makeQuery(request.query),
  });

//웹흑 이벤트 내역 목록 조회 -> 완료
const getWebhookEventHistoryList = async (
  request: getWebhookEventListRequest
): Promise<getWebhookEventListResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/webhook/subscriptions/${request.params.subscriptionId}/webhooks`,
    query: makeQuery(request.query),
  });

//웹흑 이벤트 기록 목록 "전체" 조회
const getWebhookEventHistoryListAll = async (
  request: getWebhookEventHistoryListAllRequest
): Promise<getWebhookEventHistoryListAllResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/webhook/logs`,
    query: makeQuery(request.query),
  });

//웹훅 재시도 -> 완료
const retryFailedSubscribeWebhook = async (
  request: retryFailedSubscribeWebhookRequest
): Promise<retryFailedSubscribeWebhookResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/webhook/subscriptions/${request.params.subscriptionId}/webhooks/${request.params.webhookId}/retry`,
    query: makeQuery(request.query),
  });

//웹훅 테스트 -> 완료
const requestTestWithWebhook = async (
  request: requestTestWithWebhookRequest
): Promise<requestTestWithWebhookResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/webhook/subscriptions/${request.params.subscriptionId}/test`,
    query: makeQuery(request.query),
  });

export {
  deleteSubscribeWebhookDetail as deleteSubscribeWebhookDetailFromServer,
  getEventType as getEventTypeFromServer,
  getWebhookDetail as getWebhookDetailFromServer,
  getWebhookEventHistoryList as getWebhookEventHistoryListFromServer,
  getWebhookList as getWebhookListFromServer,
  requestTestWithWebhook as requestTestWithWebhookFromServer,
  subscribeWebhook as subscribeWebhookFromServer,
  updateSubscribeWebhookDetail as updateSubscribeWebhookDetailFromServer,
  retryFailedSubscribeWebhook as retryFailedSubscribeWebhookFromServer,
  getWebhookEventHistoryListAll as getWebhookEventHistoryListAllFromServer,
};
